import { useEffect, useState } from "react";
import api from "../../api/client";
import { formatPrice } from "../../lib/format";

export default function BubeOrderBook({ coin, refreshKey }) {
    const [book, setBook] = useState({ bulls: [], bears: [] });

    const load = async () => {
        try {
            const { data } = await api.get(`/swaps/orderbook?coin=${coin}`);
            setBook(data);
        } catch {}
    };

    useEffect(() => {
        if (!coin) return;
        load();
        const id = setInterval(load, 2000);
        return () => clearInterval(id);
    }, [coin, refreshKey]);

    return (
        <div className="bg-[#0A0A0C] border border-[#1F1F24] rounded-sm" data-testid="bube-orderbook">
            <div className="px-4 py-3 border-b border-[#1F1F24]">
                <div className="text-[10px] font-mono uppercase tracking-[0.22em] text-zinc-500">BUBE Open Orders</div>
                <div className="text-sm font-medium font-mono tracking-tight mt-0.5">Awaiting match · {coin}</div>
            </div>
            <div className="grid grid-cols-2 gap-1 p-1">
                <Column title="BULL" color="text-emerald-400" rows={book.bulls} />
                <Column title="BEAR" color="text-rose-400" rows={book.bears} />
            </div>
        </div>
    );
}

function Column({ title, color, rows }) {
    return (
        <div className="bg-[#050505] border border-[#1F1F24] rounded-sm">
            <div className={`px-2.5 py-2 border-b border-[#1F1F24] text-[10px] font-mono uppercase tracking-[0.22em] ${color}`}>
                {title} · {rows.length}
            </div>
            <div className="grid grid-cols-3 px-2 py-1 text-[9px] font-mono uppercase tracking-[0.18em] text-zinc-500 border-b border-[#1F1F24]">
                <span>Notional</span>
                <span className="text-right">Margin</span>
                <span className="text-right">Dur</span>
            </div>
            <div className="max-h-[200px] overflow-y-auto">
                {rows.length === 0 && (
                    <div className="px-2 py-3 text-center text-[10px] font-mono text-zinc-600">— empty —</div>
                )}
                {rows.map((o) => (
                    <div key={o.id} className="grid grid-cols-3 px-2 py-1 text-[11px] font-mono border-t border-[#1F1F24]/40">
                        <span className="text-zinc-300">{o.notional.toLocaleString()}</span>
                        <span className="text-right text-zinc-400">{o.margin.toLocaleString()}</span>
                        <span className="text-right text-zinc-500">{o.duration_key}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
